export const JUNO_ERROR_NO_TIMESTAMP_PROVIDED = 'juno.error.no_timestamp_provided';
export const JUNO_ERROR_TIMESTAMP_OUTDATED_OR_FUTURE = 'juno.error.timestamp_outdated_or_future';
export const JUNO_ERROR_NO_VERSION_PROVIDED = 'juno.error.no_version_provided';
export const JUNO_ERROR_VERSION_OUTDATED_OR_FUTURE = 'juno.error.version_outdated_or_future';

export const JUNO_DATASTORE_ERROR_CANNOT_WRITE = 'juno.datastore.error.cannot_write';
export const JUNO_DATASTORE_ERROR_CANNOT_READ = 'juno.datastore.error.cannot_read';

export const JUNO_STORAGE_ERROR_UPLOAD_NOT_ALLOWED = 'juno.storage.error.upload_not_allowed';
export const JUNO_STORAGE_ERROR_SET_NOT_ALLOWED = 'juno.storage.error.set_not_allowed';
export const JUNO_STORAGE_ERROR_CANNOT_COMMIT_INVALID_COLLECTION =
  'juno.storage.error.cannot_commit_invalid_collection';
export const JUNO_STORAGE_ERROR_CANNOT_COMMIT_BATCH = 'juno.storage.error.cannot_commit_batch';
export const JUNO_STORAGE_ERROR_ASSET_NOT_FOUND = 'juno.storage.error.asset_not_found';
export const JUNO_STORAGE_ERROR_CANNOT_READ_ASSET = 'juno.storage.error.cannot_read_asset';
export const JUNO_STORAGE_ERROR_UPLOAD_PATH_COLLECTION_PREFIX =
  'juno.storage.error.upload_path_collection_prefix';
export const JUNO_STORAGE_ERROR_RESERVED_ASSET = 'juno.storage.error.reserved_asset';
export const JUNO_STORAGE_ERROR_BATCH_NOT_FOUND = 'juno.storage.error.batch_not_found';
export const JUNO_STORAGE_ERROR_CHUNK_NOT_FOUND = 'juno.storage.error.chunk_not_found';
export const JUNO_STORAGE_ERROR_CHUNK_NOT_INCLUDED_IN_BATCH =
  'juno.storage.error.chunk_not_included_in_batch';
export const JUNO_STORAGE_ERROR_CHUNK_TO_COMMIT_NOT_FOUND =
  'juno.storage.error.chunk_to_commit_not_found';
export const JUNO_STORAGE_ERROR_ASSET_MAX_ALLOWED_SIZE =
  'juno.storage.error.asset_max_allowed_size';

export const JUNO_AUTH_ERROR_NOT_ADMIN_CONTROLLER = 'juno.auth.error.not_admin_controller';
export const JUNO_AUTH_ERROR_INVALID_ORIGIN = 'juno.auth.error.invalid_origin';
export const JUNO_AUTH_ERROR_NOT_WRITE_CONTROLLER = 'juno.auth.error.not_write_controller';
export const JUNO_AUTH_ERROR_NOT_CONTROLLER = 'juno.auth.error.not_controller';

export const JUNO_DATASTORE_ERROR_USER_CANNOT_UPDATE = 'juno.datastore.error.user.cannot_update';
export const JUNO_DATASTORE_ERROR_USER_INVALID_DATA = 'juno.datastore.error.user.invalid_data';
export const JUNO_DATASTORE_ERROR_USER_CALLER_KEY = 'juno.datastore.error.user.caller_key';
export const JUNO_DATASTORE_ERROR_USER_KEY_NO_PRINCIPAL =
  'juno.datastore.error.user.key_no_principal';
export const JUNO_DATASTORE_ERROR_USER_NOT_ALLOWED = 'juno.datastore.error.user.not_allowed';
export const JUNO_DATASTORE_ERROR_USER_USAGE_CHANGE_LIMIT_REACHED =
  'juno.datastore.error.user.usage.change_limit_reached';
export const JUNO_DATASTORE_ERROR_USER_USAGE_INVALID_DATA =
  'juno.datastore.error.user.usage.invalid_data';
